export const readableProjectUnion = (union: string) => {
  switch (union.toLocaleLowerCase()) {
    case 'actra':
      return 'ACTRA';
    case 'aea':
      return 'AEA';
    case 'caea':
      return 'CAEA';
    case 'equity':
      return 'Equity';
    case 'meaa':
      return 'MEAA';
    case 'no_union_affiliation':
    case 'no union affiliation':
      return 'No Union Affiliation';
    case 'non_union':
      return 'Non Union';
    case 'other':
      return 'Other';
    case 'sag_aftra':
    case 'sag/aftra':
      return 'SAG/AFTRA';
    case 'ubcp/actra':
    case 'ubcp_actra':
      return 'UBCP / ACTRA';
    case 'uda':
      return 'UDA';
    default:
      return undefined;
  }
};

export const getErrorMessage = (touch: boolean | undefined, error: string | undefined) => {
  return touch && error ? error : '';
};

export interface PasswordPrinciple {
  LengthInValid: boolean;
  LowerCaseInValid: boolean;
  UpperCaseInValid: boolean;
  NumbericInValid: boolean;
  SpecialInValid: boolean;
  IsValid: boolean;
}

export const validatePassword = (password: string): PasswordPrinciple => {
  const result = {
    LengthInValid: false,
    LowerCaseInValid: false,
    UpperCaseInValid: false,
    NumbericInValid: false,
    SpecialInValid: false,
    IsValid: false,
  };

  if (password.length === 0) {
    return result;
  }

  if (password.length < 8) {
    result.LengthInValid = true;
  }

  if (!/^(?=.*[a-z])[^]{1,}$/.test(password)) {
    result.LowerCaseInValid = true;
  }

  if (!/^(?=.*[A-Z])[^]{1,}$/.test(password)) {
    result.UpperCaseInValid = true;
  }

  if (!/^(?=.*\d)[^]{1,}$/.test(password)) {
    result.NumbericInValid = true;
  }

  if (!/^(?=.*[~`!@#$%^&*()\-_+={}[\]|;:"<>,./?])[^]{1,}$/.test(password)) {
    result.SpecialInValid = true;
  }

  result.IsValid =
    !result.SpecialInValid &&
    !result.NumbericInValid &&
    !result.UpperCaseInValid &&
    !result.LowerCaseInValid &&
    !result.LengthInValid;

  return result;
};

export enum AuditionType {
  StudioSession = 'studio',
  SelfTapes = 'self_tapes',
}

export const auditionTypeParser = (auditionType: AuditionType) => {
  return auditionType === AuditionType.SelfTapes ? 'Self-Tapes' : 'Studio';
};

export const ellipseText = (text: string, count = 30) => {
  if (text) {
    return text.length > count ? text.substring(0, count) + '...' : text;
  }
  return '';
};

export const secondsToTime = (seconds: number): string => {
  return new Date(seconds * 1000).toISOString().substr(14, 5);
};

export interface IErrorResponse {
  errors: {
    [key: string]: string[];
  };
}

type ErrorValues = {
  [key: string]: string[];
};

const humanizeString = (str: string) => {
  return str
    .replace(/^[\s_]+|[\s_]+$/g, '')
    .replace(/[_\s]+/g, ' ')
    .replace(/^[a-z]/, function (m) {
      return m.toUpperCase();
    });
};

export const errorResponseToArray = (error: ErrorValues): string => {
  return Object.entries(error)
    .reduce((acc: string[], curr) => {
      const [key, value] = curr;
      const text = humanizeString(`${key} ${value.join(',')}`);
      return [...acc, text];
    }, [])
    .join('. ');
};

export const formatBytes = (bytes: number) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export interface IProgressEvent {
  loaded: number;
  total: number;
}

export const computeProgressEvent = (progressEvent: IProgressEvent) => {
  return (progressEvent.loaded / progressEvent.total) * 100;
};
